import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMedia } from './chatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMedia';

export type ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezero = {
  /** 미디어 정보 */
  media?: ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMedia;
};
